import { Router } from '@angular/router';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Modal } from '@clr/angular';
import { Dropdown } from '@clr/angular';
import { VcaAlertsService } from './../../../../common/vca-alerts';
import { TABS_DIRECTIVES } from '@clr/angular';

var clipboardJs = require("clipboard-js")
let fullScreenOverlayHost = require('../utils/fullScreenOverlayHost');
const _ = require('lodash');

@Component({
    selector: 'auditlog-dialog',
    template: require('./auditlog-dialog.html'),
    styles: [require('./auditlog-dialog.scss')]
})

export default class AuditLogDialogComponent implements OnInit {
    showDialog: boolean = false;
    @Input() eventJsonData: any;
    private eventIndex = 0;

    constructor(private router: Router,
        private cdRef: ChangeDetectorRef,
        private alert: VcaAlertsService) {
    }

    ngOnInit() {
        this.showDialog = false;
    }

    initApplication() {
    }

    show(i) {
        this.eventIndex = i;
        this.showDialog = true;
    }
   
    close() {
        this.showDialog = false;
    }

    getText(json) {
        const text = [];
        let me = this;    
        _.each(json, function(item, i) {
            if (i === me.eventIndex) {
                Object.keys(item).forEach(key => {
                    text.push(key + ': ' + item[key]);
                }); 
            }
        })
        return text.join('\r\n');
    }
}


// WEBPACK FOOTER //
// ./src/auditlog/src/auditlog-ui/auditlog-dialog/auditlog-dialog.component.ts